import React, { useRef, useEffect, useState } from "react";
import ClienteAutocomplete from "../../../components/autocomplete/ClienteAutocomplete";
import EessAutocomplete from "../../../components/autocomplete/EessAutocomplete";
import ProductoAutocomplete from "../../../components/autocomplete/ProductoAutocomplete";
import TarjetasAutocomplete from "../../../components/autocomplete/TarjetasAutocomplete";

export default function FiltroDescuento({
  initialFilters = {},
  onClose = () => {},
  onSubmit = () => {},
}) {

  const filtroRef = useRef(null);

  // =========================
  // ESTADOS
  // =========================
  const [cliente, setCliente] = useState(null);
  const [eess, setEess] = useState(null);

  const [producto, setProducto] = useState(null);
  const [tarjeta, setTarjeta] = useState(null);

  const [totalValor, setTotalValor] = useState("");
  const [totalPct, setTotalPct] = useState("");

  const [valorEess, setValorEess] = useState("");
  const [pctEess, setPctEess] = useState("");

  const [valorPetr, setValorPetr] = useState("");
  const [pctPetr, setPctPetr] = useState("");

  const [fechaIni, setFechaIni] = useState("");
  const [fechaFin, setFechaFin] = useState("");

 // =========================
  // 🔄 REHIDRATAR FILTROS
  // =========================
  useEffect(() => {
    setCliente(initialFilters.cliente || null);
    setEess(initialFilters.eess || null);
    setProducto(initialFilters.producto || null);
    setTarjeta(initialFilters.tarjeta || null);

    setTotalValor(initialFilters.totalValor ?? "");
    setTotalPct(initialFilters.totalPct ?? "");

    setValorEess(initialFilters.valorEess ?? "");
    setPctEess(initialFilters.pctEess ?? "");

    setValorPetr(initialFilters.valorPetr ?? "");
    setPctPetr(initialFilters.pctPetr ?? "");

    setFechaIni(initialFilters.fechaInicio ?? "");
    setFechaFin(initialFilters.fechaFin ?? "");
  }, [initialFilters]);

  // =========================
  // Cerrar al hacer clic fuera o ESC
  // =========================
  useEffect(() => {
    const outside = (e) => {
      if (filtroRef.current && !filtroRef.current.contains(e.target)) {
        onClose();
      }
    };
    const esc = (e) => e.key === "Escape" && onClose();

    document.addEventListener("mousedown", outside);
    document.addEventListener("keydown", esc);

    return () => {
      document.removeEventListener("mousedown", outside);
      document.removeEventListener("keydown", esc);
    };
  }, [onClose]);

  // =========================
  // SUBMIT
  // =========================
  const handleSubmit = (e) => {
    e.preventDefault();

    onSubmit({
      // ✅ ids para backend
      clienteId: cliente?.id ?? null,
      eessId: eess?.id ?? null,
      productoId: producto?.id ?? null,
      tarjetaId: tarjeta?.id ?? null,

      // ✅ objetos para rehidratar UI
      cliente: cliente ?? null,
      eess: eess ?? null,
      producto: producto ?? null,
      tarjeta: tarjeta ?? null,

      // resto
      totalValor: totalValor || null,
      totalPct: totalPct || null,
      valorEess: valorEess || null,
      pctEess: pctEess || null,
      valorPetr: valorPetr || null,
      pctPetr: pctPetr || null,
      fechaInicio: fechaIni || null,
      fechaFin: fechaFin || null,
    });

  };

  // =========================
  // RENDER
  // =========================
  return (
    <div className="drawer-backdrop">
      <div
        ref={filtroRef}
        onClick={(e) => e.stopPropagation()}
        className="drawer-panel overflow-auto"
      >
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-title">Filtros</h2>
          <button onClick={onClose} className="btn-cancel" title="Cerrar">
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-4">
          {/* Cliente */}
          <div>
            <label className="form-label-fil">Cliente</label>
            <ClienteAutocomplete
              value={cliente}
              onChange={setCliente}
              placeholder="Buscar cliente..."
            />
          </div>

          {/* EE.SS. */}
          <div>
            <label className="form-label-fil">EE.SS.</label>
            <EessAutocomplete
              value={eess}
              onChange={setEess}
              placeholder="Buscar EE.SS..."
            />
          </div>

          {/* Producto */}
          <div>
            <label className="form-label-fil">Cód. Producto</label>
            <ProductoAutocomplete
              value={producto}
              onChange={setProducto}
              placeholder="Buscar producto..."
            />
          </div>

          {/* Tarjeta */}
          <div>
            <label className="form-label-fil">Nro. de Tarjeta</label>
            <TarjetasAutocomplete
              value={tarjeta}
              onChange={setTarjeta}
              placeholder="Buscar tarjeta..."
              estadoId={29}   // 👈 SOLO TARJETAS ACTIVAS
            />
          </div>

          {/* Total Valor */}
          <div>
            <label className="form-label-fil">
              Total Descuento Valor PYG
            </label>
            <input
              type="number"
              className="input"
              value={totalValor}
              onChange={(e) => setTotalValor(e.target.value)}
            />
          </div>

          {/* Total % */}
          <div>
            <label className="form-label-fil">Total Descuento %</label>
            <input
              type="number"
              className="input"
              value={totalPct}
              onChange={(e) => setTotalPct(e.target.value)}
            />
          </div>

          {/* EE.SS. Valor */}
          <div>
            <label className="form-label-fil">Valor PYG EE.SS.</label>
            <input
              type="number"
              className="input"
              value={valorEess}
              onChange={(e) => setValorEess(e.target.value)}
            />
          </div>

          {/* EE.SS. % */}
          <div>
            <label className="form-label-fil">EE.SS. %</label>
            <input
              type="number"
              className="input"
              value={pctEess}
              onChange={(e) => setPctEess(e.target.value)}
            />
          </div>

          {/* Petrobras Valor */}
          <div>
            <label className="form-label-fil">Valor PYG Petr.</label>
            <input
              type="number"
              className="input"
              value={valorPetr}
              onChange={(e) => setValorPetr(e.target.value)}
            />
          </div>

          {/* Petrobras % */}
          <div>
            <label className="form-label-fil">Petr. %</label>
            <input
              type="number"
              className="input"
              value={pctPetr}
              onChange={(e) => setPctPetr(e.target.value)}
            />
          </div>

          {/* Fechas */}
          <div>
            <label className="form-label-fil">Fecha Inicio</label>
            <input
              type="date"
              className="input"
              value={fechaIni}
              onChange={(e) => setFechaIni(e.target.value)}
            />
          </div>

          <div>
            <label className="form-label-fil">Fecha Final</label>
            <input
              type="date"
              className="input"
              value={fechaFin}
              onChange={(e) => {
                const value = e.target.value;
                setFechaFin(value);

                if (!fechaIni && value) {
                  const d = new Date(value);
                  d.setDate(d.getDate() - 1);
                  setFechaIni(d.toISOString().slice(0, 10));
                }
              }}
            />
          </div>

          {/* BOTÓN */}
          <div className="text-right pt-4">
            <button type="submit" className="btn btn-success">
              Aplicar filtros
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
